import { createConsumer } from '@rails/actioncable';
import { API_URL } from '../config/api';

// Derive WebSocket base from the HTTP API URL
function getCableUrl(token) {
  const base = (import.meta.env.VITE_CABLE_URL || API_URL).replace(/^http/, 'ws');
  return `${base}/cable?token=${encodeURIComponent(token)}`;
}

let consumer = null;
let consumerToken = null;

export function getConsumer(token) {
  if (consumer && consumerToken === token) return consumer;
  // Token changed or first call — create a fresh consumer
  if (consumer) {
    consumer.disconnect();
    consumer = null;
  }
  consumer = createConsumer(getCableUrl(token));
  consumerToken = token;
  return consumer;
}

export function disconnectConsumer() {
  if (consumer) {
    consumer.disconnect();
    consumer = null;
    consumerToken = null;
  }
}
